/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentPlanName/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Description from 'DesignSystem/Description/index'
import DescriptionLabel from 'DesignSystem/DescriptionLabel/index'
import DescriptionValue from 'DesignSystem/DescriptionValue/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TreatmentPlanName({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanName"
  
}) {
let treatmentCardTxsTxPlanNameValueData = fromData.useDataValue({ viewPath,
context: 'treatment_card',
path: 'txs.tx_plan.name',
})
let constantData = 'No treatment plan'
let aggregateData = fromAggregate.any(treatmentCardTxsTxPlanNameValueData, constantData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<Description
  viewPath={`${viewPath}/Description`}
 justifyContent="flex-start"
>
{childProps => (
<React.Fragment>
<DescriptionLabel
{...childProps}
  viewPath={`${viewPath}/DescriptionLabel`}
 alignItems="flex-start"
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="semibold"
 text="Tx plan"
/>
)}
</DescriptionLabel>
<DescriptionValue
{...childProps}
  viewPath={`${viewPath}/DescriptionValue`}
 alignSelf="center"
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral900}
 marginLeft={dtSpaceXxs}
 data="treatment_card.txs.tx_plan.name"
 data="'No treatment plan'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData}
/>
)}
</DescriptionValue>
</React.Fragment>
)}
</Description>
{children}
</React.Fragment>)
}